import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import FotosSlider from '../components/FotosSlider'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import PageEye from '../components/PageEye'
import imgTv from '../img/tv-mockup2.png'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  h2,
  p {
    color: #ffffff;
  }
  @media ${device.mobileL} {
    padding: 2em;
    p {
      text-align: left;
    }
  }
  .fundo {
    background-color: #ffffff;
    font-size: 0.8em;
    margin-bottom: 20px;
    padding: 30px;
    p {
      color: ${colors.cinza};
    }
  }
  iframe {
    width: 100%;
    height: 460px;
    margin: 2em 0 1em;
    @media ${device.mobileL} {
      height: 260px;
    }
  }
  :nth-of-type(2) {
    background: ${colors.lilasGradiente};
  }
  :nth-of-type(4) {
    padding-top: 0;
    p {
      color: ${colors.lilas};
      padding: 20px 0;
    }
  }
`
export const TelaoTemplate = ({
  title,
  content,
  image,
  slug,
  color,
  area = 'Estrutura',
  galeria,
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          imgWidth="68%"
          height="204px"
          bottom="0"
        />
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[0].tituloDaSessao)}</h2>
            {parse(sessoes[0].texto)}
          </div>
        </GroupContent>
        <PageEye
          color="lilas-vermelho"
          image={sessoes[1].imagemDaSessao.sourceUrl}
          imgWidth="38%"
          imgWidthMobile="100%"
          imgMarginMobile="0"
          right="30px"
          titleWidth="506px"
          overflow="visible"
          title={sessoes[1].tituloDaSessao}
          content={sessoes[1].texto}
        />
        <GroupContent>
          <div className="center">
            {parse(sessoes[2].texto)}
            <div>
              <FotosSlider fotos={galeria} />
            </div>
          </div>
        </GroupContent>
      </Container>
    </>
  )
}

TelaoTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const Telao = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const { galeria } = page.galeria
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <TelaoTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        galeria={galeria}
        sessoes={sessoes}
      />

      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

Telao.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Telao

export const TelaoQuery = graphql`
  query TelaoById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      galeria {
        galeria {
          id
          altText
          title
          sourceUrl
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
